import React from "react";
import { Link } from "react-router-dom";

const SingleService = (props) => {
  return (
    <div className="single-service">
      <h3>{props.name}</h3>
      <img alt="ooops" src={props.img} className="single-service-img" />

      <p className="service-summary"> {props.summary}</p>

      <Link to={props.route}>
        <button className="learn-more-services">Learn More <span> &gt;&gt;&gt; </span> </button>
      </Link>
    </div>
  );
};
export default SingleService;
